export const MUTATION_DELETE_DISCOUNT = /* GraphQL */ `
	mutation ($id: String!) {
		deleteDiscount(id: $id)
	}
`;
